export default {
  namespaced: true,
  security_self_audit: {
    title: "Auto Auditoría de Seguridad",
    security_self_audits_title: "Auto Auditorías de Seguridad",
    index: "Índice",
    select_reviewer: "Selecciona usuario revisor",
    template_composed: "Compuesto",
    save_failed: "No se pudo guardar",
    template: {
      title: "Plantillas de Formulario",
      name: "Nombre",
      question: "Pregunta",
      add_new_field: "Agregar un Nuevo Campo",
      type_response: "Tipo de Respuesta",
      field_name: "Nombre del Campo",
      field_types: "Tipos de Campo",
      field_type_config: "Configuración del Tipo de Campo",
      options: "Opciones",
      option_name: "Nombre de la Opción",
      add_option: "Agregar una Opción",
      added_options: "Opciones Agregadas",
    },
    form_validations: {
      name: "El nombre es obligatorio",
      type: "El tipo es obligatorio",
    },
    form: {
      title: "Formulario de Riesgo",
    },
    required: "Requerido",
    close: "Cerrar",
    Apply: "Aplicar",
    comment: "Comentario",
    file: "Archivos",
    select_template: "Seleccionar Plantilla",
    review_comments: "Comentarios de Revision",
    reference_number: "Referencia",
    template_name: "Nombre de la Plantilla",
    btn_start_form: "Empezar Formulario",
    btn_send_to_review: "Mandar a Revisión",
    btn_approve: "Aprobar",
    btn_reject: "Rechazar",
    btn_reassign: "Reasignar",
    btn_add_comment: "Agregar Comentario",
    add_comment_placeholder: "Agrega un comentario...",
    states: {
      title: "Estado",
      created: "Creado",
      in_progress: "En Progreso",
      in_review: "En Revisión",
      approved: "Aprobado",
      not_approved: "No Aprobado",
      reassigned: "Reasignado",
      reasigned: "Reasignado",
      cancelled: "Cancelado",
      canceled: "Cancelado",
    },
    history: {
      title: "Historial",
      user: "Usuario",
      date: "Fecha",
      note: "Nota",
      entries: "entradas",
      empty: "Sin movimientos",
      show_less: "Ver menos",
      show_all: "Ver todo el historial"
    },
    fill_form: "Auditoría creada. Complete el formulario ahora.",
    failed_create_audit: "Error al crear la auditoría",
    answers_saved: "Respuestas guardadas",
    error_loading_audit: "Error al cargar la auditoría de seguridad",
    status_updated: "Estado actualizado a {newStatus}",
    failed_update_status: "No se pudo actualizar el estado",
    status: "Estado",
    new_audit: "Nueva auditoría"
  },
  confirm_cancel: "¿Estás seguro de que deseas cancelar esta auditoría?",
  canceled: "Auditoría cancelada",
};
